import { ReactNode } from 'react';

import classNames from 'classnames';

import './styles/form-group.scss';

type FormGroupProps = {
  children?: ReactNode,
  className?: string
}

const FormGroup= ({
  className,
  children,
}:FormGroupProps) => {
  return (
    <div className={ classNames('form-field--group', className) }>{children}</div>
  );
};

export default FormGroup;
